import React from "react";
import Panel from "muicss/lib/react/panel";
import axios from "axios";
import { scale, format } from "d3";

export default class Metrics extends React.Component {
  constructor(props) {
    super(props);
    this.panel = null;
    this.colorScale = scale.category10();
    this.state = {
      metricsArraylimit: "min",
      metricsArray: [{ name: "", value: "" }],
      Metrics: {},
      loading: true,
      chartWidth: 400,
      chartHeigth: this.props.chartHeigth || 120,
    };
    this.url = `${this.props.horizonURL}/metrics`;
  }

  getMetrics() {
    fetch(this.url)
      .then(function(response) {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          Metrics: myJson,
          loading: false,
        });
        setTimeout(() => {
          this.processMetrics();
        }, 500);
      });
  }

  processMetrics() {
    let metricsArray = [];
    metricsArray.push({
      name: "history latest ledger",
      value: this.state.Metrics["history.latest_ledger"].value,
    });
    metricsArray.push({
      name: "core latest ledger",
      value: this.state.Metrics["stellar_core.latest_ledger"].value,
    });
    metricsArray.push({
      name: "gap status",
      value: Math.abs(
        parseInt(this.state.Metrics["stellar_core.latest_ledger"].value) -
          parseInt(this.state.Metrics["history.latest_ledger"].value),
      ),
    });
    metricsArray.push({
      name: "tx succeeded (15m rate)",
      value: this.state.Metrics["txsub.succeeded"]["15m.rate"],
    });
    metricsArray.push({
      name: "tx succeeded (1m rate)",
      value: this.state.Metrics["txsub.succeeded"]["1m.rate"],
    });
    metricsArray.push({
      name: "tx succeeded (5m rate)",
      value: this.state.Metrics["txsub.succeeded"]["5m.rate"],
    });
    metricsArray.push({
      name: "tx succeeded (count)",
      value: this.state.Metrics["txsub.succeeded"]["count"],
    });
    metricsArray.push({
      name: "tx succeeded (mean rate)",
      value: this.state.Metrics["txsub.succeeded"]["mean.rate"],
    });
    metricsArray.push({
      name: "tx open",
      value: this.state.Metrics["txsub.open"].value,
    });
    metricsArray.push({
      name: "tx failed (15m rate)",
      value: this.state.Metrics["txsub.failed"]["15m.rate"],
    });
    metricsArray.push({
      name: "tx failed (1m rate)",
      value: this.state.Metrics["txsub.failed"]["1m.rate"],
    });
    metricsArray.push({
      name: "tx failed (5m rate)",
      value: this.state.Metrics["txsub.failed"]["5m.rate"],
    });
    metricsArray.push({
      name: "tx failed (count)",
      value: this.state.Metrics["txsub.failed"]["count"],
    });
    metricsArray.push({
      name: "tx failed (mean rate)",
      value: this.state.Metrics["txsub.failed"]["mean.rate"],
    });
    metricsArray.push({
      name: "history open connections",
      value: this.state.Metrics["history.open_connections"].value,
    });
    metricsArray.push({
      name: "ingester clear ledger mean",
      value: this.state.Metrics["ingester.clear_ledger"]["mean"],
    });
    metricsArray.push({
      name: "ingester clear ledger stddev",
      value: this.state.Metrics["ingester.clear_ledger"]["stddev"],
    });
    metricsArray.push({
      name: "ingester ingest ledger mean",
      value: this.state.Metrics["ingester.ingest_ledger"]["mean"],
    });
    metricsArray.push({
      name: "ingester ingest ledger stddev",
      value: this.state.Metrics["ingester.ingest_ledger"]["stddev"],
    });
    metricsArray.push({
      name: "logging error (mean rate)",
      value: this.state.Metrics["logging.error"]["mean.rate"],
    });
    metricsArray.push({
      name: "logging info (mean rate)",
      value: this.state.Metrics["logging.info"]["mean.rate"],
    });
    metricsArray.push({
      name: "logging panic (mean rate)",
      value: this.state.Metrics["logging.panic"]["mean.rate"],
    });
    metricsArray.push({
      name: "logging warning (mean rate)",
      value: this.state.Metrics["logging.warning"]["mean.rate"],
    });
    metricsArray.push({
      name: "requests failed (mean rate)",
      value: this.state.Metrics["requests.failed"]["mean.rate"],
    });
    metricsArray.push({
      name: "requests succeeded (mean rate)",
      value: this.state.Metrics["requests.succeeded"]["mean.rate"],
    });
    metricsArray.push({
      name: "requests total (mean rate)",
      value: this.state.Metrics["requests.total"]["stddev"],
    });
    metricsArray.push({
      name: "ingester.clear_ledger",
      value: this.state.Metrics["ingester.clear_ledger"].value,
    });
    metricsArray.push({
      name: "ingester.clear_ledger",
      value: this.state.Metrics["ingester.clear_ledger"].value,
    });
    metricsArray.push({
      name: "ingester.clear_ledger",
      value: this.state.Metrics["ingester.clear_ledger"].value,
    });

    this.setState({ metricsArray });
  }

  componentDidMount() {
    this.getMetrics();
    setInterval(() => {
      this.processMetrics();
    }, 60000);
  }

  render() {
    return (
      <div
        ref={(el) => {
          this.panel = el;
        }}
      >
        <Panel style={{ marginBottom: "10em" }}>
          <div className="widget-name">
            <p
              style={{
                textAlign: this.props.lang == "persian" ? "right" : "left",
              }}
            >
              {this.props.dictionary["metricsInformation"][this.props.lang]}
              <br />
            </p>

            <a href={this.url} target="_blank" className="api-link">
              API
            </a>
          </div>
          {this.state.loading ? (
            "Loading..."
          ) : (
            <table className="mui-table small">
              <thead>
                <tr>
                  <th>{this.props.dictionary["metric"][this.props.lang]}</th>
                  <th>{this.props.dictionary["value"][this.props.lang]}</th>
                </tr>
              </thead>
              <tbody style={{ transition: "all 1s" }}>
                {this.state.metricsArraylimit == "min"
                  ? [...this.state.metricsArray.slice(1, 10)].map((item) => (
                      <tr>
                        <td style={{ textAlign: "left", color: "#2196F3" }}>
                          {item.name}
                        </td>
                        <td style={{ textAlign: "left" }}>{item.value}</td>
                      </tr>
                    ))
                  : [...this.state.metricsArray].map((item) => (
                      <tr>
                        <td style={{ textAlign: "left", color: "#2196F3" }}>
                          {item.name}
                        </td>
                        <td style={{ textAlign: "left" }}>{item.value}</td>
                      </tr>
                    ))}

                {
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    {this.state.metricsArraylimit == "min" ? (
                      <td
                        style={{ textAlign: "right", cursor: "pointer" }}
                        onClick={() =>
                          this.setState({ metricsArraylimit: "max" })
                        }
                      >
                        {this.props.dictionary["more"][this.props.lang]}
                      </td>
                    ) : (
                      <td
                        style={{ textAlign: "right", cursor: "pointer" }}
                        onClick={() =>
                          this.setState({ metricsArraylimit: "min" })
                        }
                      >
                        {this.props.dictionary["less"][this.props.lang]}
                      </td>
                    )}
                  </tr>
                }
              </tbody>
            </table>
          )}
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/components/Metrics.js